var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.062 13.574C12.1993 13.6366 12.3446 13.6666 12.4873 13.6666C12.7513 13.6666 13.01 13.5626 13.206 13.364C13.5146 13.0526 13.5866 12.5993 13.392 12.2086L8.90796 3.22663C8.7353 2.88063 8.38663 2.66663 7.99863 2.66663C7.61063 2.66663 7.26263 2.88063 7.08996 3.22663L2.60796 12.204V12.2046C2.41263 12.596 2.48663 13.0493 2.7953 13.36C3.09863 13.6646 3.5493 13.7473 3.94063 13.5673L7.97596 11.7206L12.062 13.574ZM8.40063 10.812C8.2673 10.7513 8.12396 10.7213 7.97996 10.7213C7.8353 10.7213 7.69063 10.752 7.5553 10.8133L3.51596 12.654C3.51596 12.6526 3.51663 12.65 3.5193 12.6446L7.99663 3.66796L12.4866 12.6653L8.40063 10.812Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.142bcf3425f4745b716f15b20395f701.svg";
export { ForwardRef as ReactComponent };